import { CategoryRepository } from '../../domain/repositories/category.repository';
import { CategoryEntity } from '../../domain/entities/category.entity';

export class GetCategoriesUseCase {
  constructor(
    private readonly categoryRepository: CategoryRepository | { getCategories: (options?: any) => Promise<CategoryEntity[]> }
  ) {}

  async execute(options?: {
    activeOnly?: boolean;
    search?: string;
    includeSubcategories?: boolean;
  }): Promise<CategoryEntity[]> {
    return this.categoryRepository.getCategories(options);
  }
}
